import wrapValidator from '../wrapValidator';

var tuple = function tuple() {
  for (var _len = arguments.length, types = new Array(_len), _key = 0; _key < _len; _key++) {
    types[_key] = arguments[_key];
  }

  var validator = function validator(props, propName, componentName, location, propFullName, secret) {
    var value = props[propName];

    if (!Array.isArray(value)) {
      return "Invalid ".concat(location, " `").concat(propFullName, "`  supplied to `").concat(componentName, "`, ") + "expected ".concat(types.length, "-element array.");
    }

    if (value.length !== types.length) {
      return "Invalid ".concat(location, " `").concat(propFullName, "`  supplied to `").concat(componentName, "`, ") + "expected ".concat(types.length, "-element array, got array of length ").concat(value.length, ".");
    }

    for (var i = 0; i < value.length; i += 1) {
      var error = types[i](value, i, componentName, 'element', "".concat(propFullName, "[").concat(i, "]"), secret);

      if (error instanceof Error) {
        return error;
      }
    }

    return null;
  };

  return wrapValidator(validator);
};

export default tuple;